import React, { useState } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Label,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Badge,
  Collapse,
} from 'reactstrap';
import Card from '@components/Card/Card';
import FlowLink from '@components/Flow/FlowLink';
import FlowParkedDomain from '@components/Flow/FlowParkedDomain';
import FlowSubAccount from '@components/Flow/FlowSubAccount/FlowSubAccount';
import FlowAgencies from '@components/Flow/FlowAgencies';
import FlowAgencyBanner from '@components/Flow/FlowAgencyBanner';
import FlowTitle from '@components/Flow/FlowTitle';
import FlowSources from '@components/Flow/FlowSources';
import FlowOffers from '@components/Flow/FlowOffers';
import FlowLandingFeatures from '@components/Flow/FlowLandingFeatures';
import FlowLandingsTable from '@components/Flow/FlowLandingsTable';
import FlowPostback from '@themes/4/components/Flow/FlowPostback';
import FlowTrafficback from '@components/Flow/FlowTrafficback';
import FlowFailAction from '@components/Flow/FlowFailAction';
import FlowTrackers from '@components/Flow/FlowTrackers';
import FlowToggleBtns from '@components/Flow/FlowToggleBtns';
import Hint from '@components/Hint/Hint';
import AlertModal from '@modals/AlertModal/AlertModal';
import DomainUrl from '@components/Domains/DomainUrl';
import DomainDisclaimer from '@components/Domains/DomainDisclaimer';
import OfferTopLink from '@components/Offer/OfferTopLink';
import IframeConstructorModal from '@modals/IframeConstructorModal/IframeConstructorModal';
import CustomControl from '@components/CustomControl/CustomControl';
import TransitsFeatures from '@components/Flow/TransitsFeatures';
import FlowABTestFeature from '@components/Flow/FlowABTestFeature';
import FlowQRCode from '@components/Flow/FlowQRCode';
import FlowDirectLinkHint from '@components/Flow/FlowDirectLinkHint';
import { FMessage } from '@hoc/IntlComponents';
import PrelandersConstructorDisclaimer from '@components/Landings/PrelandersConstructorDisclaimer';
import FlowDeepLink from '@components/Flow/FlowDeepLink';
import Icon from '@components/Icon/Icon';
import FlowDirectLinkForm from '@components/Flow/FlowDirectLinkForm';
import FlowWarning from '../../../../components/Flow/FlowWarning';
const View = ({
  data: {
    history,
    stream,
    subAccount,
    errors,
    isClick,
    modal,
    message,
    type,
    iframeConstructorModalOpen,
    iframeConstructorSettings,
    use_transit_service,
    trackersDropdownOpen,
    isExtraSettingsOpen,
    loading,
    offers,
    sites,
    offer,
    settings,
    profile,
    isEdit,
    isCdn,
    isUserBlocked,
    site_key,
    landingsABTestEnabled,
    transitsABTestEnabled,
    deepLink,
    isPrelandersCollapseOpen,
    isUsingDirectLinkWithoutRedirectLanding,
    domainParking,
  },
  handleSubmit,
  getComputedLink,
  handleSubAccountChange,
  _alertRefs,
  handleDomainCheck,
  handleDomainChange,
  getParkingType,
  getOffersWithNoReplics,
  handleOfferChange,
  handleSiteChange,
  handleAgencyChange,
  handleRequestOfferAccess,
  handleChangeABTest,
  handleLandFeatureChange,
  sortLandingsByTotalCr,
  handleLandingChange,
  toggleIframeConstructorModal,
  handleTransitsComebackerChange,
  handleTransitFeatureChange,
  handleNewsShowcaseSettingsChange,
  handleUseTransitsChange,
  handleTransitChange,
  toggleExtraSettings,
  handlePostbackChange,
  handleStatusChange,
  handlePixelChange,
  handleTrafbackUrlChange,
  handleFailActionChange,
  handleTrackerChange,
  toggleTrackersDropdown,
  toggleModal,
  handleIframeConstructorSubmit,
  handleChange,
  setTopLink,
  getSelectedFeaturesId,
  handleDeepLinkChande,
  togglePrelandersCollapse,
  moveIframeConstructorToEnd,
  handleDirectLinkSubdomainChange,
  toggleDirectLinkWithoutRedirectLandingUsage,
  checkDirectLinkWithoutRedirect,
  showVkCabinetSubtext,
  handleClickVkWarningLink,
  showWarning,
  domainParkingToggle,
  onDomianParkingInputChange,
}) => {
  const [showFlowExtraSettings, toggleFlowExtraSettings] = useState(true);

  return (
    <Form className="flow-form" onSubmit={handleSubmit}>
      {/* Landings */}
      {offer.landings && offer.landings.length > 0 && (
        <Card loading={loading}>
          <Card.Header>
            <FormattedMessage
              id="flow.landings.title.theme_4"
              defaultMessage="Choose prelangins/landing"
            >
              {(str) => (
                <>
                  <Badge>1</Badge>
                  {str}
                </>
              )}
            </FormattedMessage>
          </Card.Header>

          {/* {isCdn && (
            <Card.Body>
              <Row className="flex-wrap-reverse">
                {offer && offer.top_bundle && (
                  <Col lg="5">
                    <OfferTopLink
                      item={offer.top_bundle}
                      offer={offer}
                      onClick={setTopLink}
                      inFlow={true}
                      disabled={stream.agency}
                    />
                  </Col>
                )}
              </Row>
            </Card.Body>
          )} */}
          {offer.transits && offer.transits.length > 0 && !stream.agency && (
            <>
              <Card.Body className="no-padding">
                {profile && profile.use_transit_service === false && (
                  <div className="flow-transit-service-control">
                    <FormGroup>
                      <CustomControl
                        id="use_transit_service"
                        name="use_transit_service"
                        className="custom-control-xs"
                        onChange={handleUseTransitsChange}
                        checked={use_transit_service}
                        value="1"
                      >
                        <FormattedMessage
                          id="profile.use_transit_service"
                          defaultMessage="Enable service «1001transits for affiliates»"
                        />
                      </CustomControl>
                    </FormGroup>
                  </div>
                )}
                <fieldset
                  disabled={
                    !stream.editable ||
                    !use_transit_service ||
                    isUsingDirectLinkWithoutRedirectLanding ||
                    domainParking.enabled
                  }
                >
                  <FlowLandingsTable
                    theme={4}
                    name="transits"
                    landingsTableType="transits"
                    landings={offer.transits}
                    domains={offer.domains.transits}
                    checked={stream.transitsId}
                    checkedLandings={stream.landingsId}
                    abTestEnabled={transitsABTestEnabled}
                    abTestDisabled={
                      isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled
                    }
                    onLandingChange={handleTransitChange}
                    offerId={offer.id}
                    abTest={stream.abTest}
                    multiple
                    site_key={site_key}
                    offer={offer}
                    streamId={stream.id}
                    inFlow
                  />
                </fieldset>
              </Card.Body>
              <Card.Body>
                <ul className="list-inline no-margin">
                  <li className="list-inline-item">
                    <a href="#" className="pseudo-link" onClick={(e) => handleTransitChange(0, e)}>
                      <FormattedMessage
                        id="flow.form.disable-prelanders"
                        defaultMessage="Reset selection"
                      />
                    </a>
                  </li>
                </ul>
                {/* <PrelandersConstructorDisclaimer /> */}
              </Card.Body>
            </>
          )}

          <Card.Body className="no-padding">
            <fieldset disabled={!stream.editable}>
              <FlowLandingsTable
                theme={4}
                name="landing"
                landingsTableType="landings"
                landings={moveIframeConstructorToEnd(offer.landings)}
                domains={offer.domains.landings}
                checked={stream.landingsId}
                checkedTransits={stream.transitsId}
                abTestEnabled={landingsABTestEnabled}
                abTestDisabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
                onLandingChange={handleLandingChange}
                offerId={offer.id}
                abTest={stream.abTest}
                toggleIframeConstructorModal={toggleIframeConstructorModal}
                multiple
                site_key={site_key}
                offer={offer}
                streamId={stream.id}
                inFlow
              />
            </fieldset>
          </Card.Body>
        </Card>
      )}
      <Card>
        <Card.Header>
          <Badge>2</Badge>
          <FormattedMessage
            id="flow.form.subid.title.theme_4"
            defaultMessage="Label (subaccounts) to track traffic"
          />
          <Hint id="flow-form-subs-label-hint" popoverClassName="flow-form-subs-label-hint">
            <FMessage id="flow.form.subs.label.hint" />
          </Hint>
        </Card.Header>
        <Card.Body>
          <FlowSubAccount onSubAccountChange={handleSubAccountChange} />
        </Card.Body>
      </Card>
      <Card className="flow-additional" id="landings-card">
        <Card.Header>
          <Badge>3</Badge>
          <FormattedMessage
            id="flow.form.features.title.theme_4"
            defaultMessage="flow.form.features.title.theme_4"
          />
        </Card.Header>
        <Card.Body>
          {offer.modifies && (
            <Card collapsing getExpandedFromProps expanded={false}>
              <Card.Header>
                <FormattedMessage
                  id="flow.form.features.landgins.title.theme_4"
                  defaultMessage="Landing Page Enhancement Tools"
                />
              </Card.Header>
              <Card.Body>
                <p>
                  <FormattedMessage
                    id="flow.form.features.landgins.subtitle.theme_4"
                    defaultMessage="You yourself can set the output settings on the landing page of tools that can enhance the envelope"
                  />
                </p>

                <fieldset disabled={!stream.editable}>
                  <FlowLandingFeatures
                    isCdn
                    abTest
                    selected={getSelectedFeaturesId(stream.features)}
                    rawFeatures={stream.features}
                    onABTestChange={handleChangeABTest}
                    onFeatureChange={handleLandFeatureChange}
                  >
                    <FlowABTestFeature selected={landingsABTestEnabled || transitsABTestEnabled} />
                  </FlowLandingFeatures>{' '}
                </fieldset>
              </Card.Body>
            </Card>
          )}
          {offer.transits && offer.transits.length > 0 && !stream.agency && (
            <Card collapsing getExpandedFromProps expanded={false}>
              <Card.Header>
                <FormattedMessage
                  id="flow.form.features.prelanders.title.theme_4"
                  defaultMessage="Prelander Enhancement Tool"
                />
              </Card.Header>
              <Card.Body>
                <p>
                  <FormattedMessage
                    id="flow.form.features.prelanders.subtitle.theme_4"
                    defaultMessage="You yourself can set the output settings on the prelander that can enhance the envelope"
                  />
                </p>

                <TransitsFeatures
                  className="no-padding"
                  disabled={
                    !stream.editable ||
                    !use_transit_service ||
                    isUsingDirectLinkWithoutRedirectLanding ||
                    domainParking.enabled
                  }
                  featuresList={stream.transitFeatures}
                  toggleComebacker={handleTransitsComebackerChange}
                  transit_comebacker={stream.transit_comebacker}
                  handleTransitFeatureChange={handleTransitFeatureChange}
                  handleNewsShowcaseSettingsChange={handleNewsShowcaseSettingsChange}
                />
              </Card.Body>
            </Card>
          )}
          <Card collapsing getExpandedFromProps expanded={false}>
            <Card.Header>
              <FormattedMessage
                id="flow.form.features.additionals.title.theme_4"
                defaultMessage="Trafficback / postback + installation of custom codes on the landing (retargeting, metric)"
              />
            </Card.Header>
            <Card.Body className="flow-trafficback-postback">
              <p className="flow-additionals-title">
                <FormattedMessage
                  id="flow.form.features.additionals.external_statistics.title.theme_4"
                  defaultMessage="Trafficback / postback + installation of custom codes on the landing (retargeting, metric"
                />
              </p>
              <p>
                <FormattedMessage
                  id="flow.form.features.additionals.external_statistics.text.1.theme_4"
                  defaultMessage="You can use the statistics of Yandex.Metrica and VK.com (Vkontakte) and others on the landing pages, prelanders and success pages"
                />
              </p>
              <p>
                <FormattedMessage
                  id="flow.form.features.additionals.external_statistics.text.2.theme_4"
                  defaultMessage="To do this, select the page on which you want to set the counter code and enter in the form below"
                />
              </p>
              <p>
                <FormattedMessage
                  id="flow.form.features.additionals.external_statistics.text.3.theme_4"
                  defaultMessage="You need to specify the ID that is used in the counter code"
                />
              </p>
              {isCdn && settings.trackers && (
                <FlowTrackers
                  className={cn('flow-trackers-card', { isOpen: isExtraSettingsOpen })}
                  trackers={settings.trackers.tracking}
                  values={stream.trackers}
                  onTrackerChange={handleTrackerChange}
                  readOnly={!stream.editable}
                  toggleTrackersDropdown={toggleTrackersDropdown}
                  trackersDropdownOpen={trackersDropdownOpen}
                />
              )}
              <p className="flow-additionals-title">
                <FormattedMessage
                  id="flow.form.features.additionals.others.title.theme_4"
                  defaultMessage="Other features"
                />
              </p>
              <p>
                <Link to="/faq/tools/flows/postback">
                  <FormattedMessage
                    id="flow.form.features.additionals.postback.faq_link.theme_4"
                    defaultMessage="Additional Postback Options info"
                  />
                </Link>
              </p>

              <Button
                color="link"
                className="no-padding mb-3 postback-extra-settings-btn"
                onClick={toggleFlowExtraSettings.bind(null, !showFlowExtraSettings)}
              >
                <FormattedMessage
                  id="flow.form.additional-settings.theme_4"
                  defaultMessage="Flow additional settings"
                />
              </Button>
              {showFlowExtraSettings && (
                <p>
                  <FormattedMessage
                    id="flow.form.features.additionals.postback.text.theme_4"
                    defaultMessage="If you need to send a request only of confirmed orders, check the box next to Send request when confirming order"
                  />
                </p>
              )}

              <FlowPostback
                showFlowExtraSettings={showFlowExtraSettings}
                streamId={stream.id}
                postback={stream.postback}
                streamPixels={stream.pixels}
                statuses={settings.postBackStatuses}
                streamStatuses={stream.statuses}
                pixels={offer.pixels}
                settings={settings}
                onPostbackChange={handlePostbackChange}
                onStatusChange={handleStatusChange}
                onPixelChange={handlePixelChange}
                className={cn('flow-postback-card', { isOpen: isExtraSettingsOpen })}
              />
            </Card.Body>
            {stream.agency === null && (
              <>
                <Card.Body className="py-0">
                  <Row>
                    <Col lg="6">
                      <FlowTrafficback
                        url={stream.trafficback}
                        onChangeTrafficbackUrl={handleTrafbackUrlChange}
                      />
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Body>
                  <FlowFailAction
                    theme={4}
                    availableFailActions={stream.failActions}
                    onChangeFailAction={handleFailActionChange}
                    offers={offers.filter(({ id }) => id !== stream.offerId)}
                  />
                </Card.Body>
              </>
            )}
          </Card>
        </Card.Body>
      </Card>

      {offer.direct_link_without_redirect && !isClick && (
        <FlowDirectLinkForm
          direct_link_without_redirect={offer.direct_link_without_redirect}
          value={stream.direct_link_without_redirect}
          onChange={handleDirectLinkSubdomainChange}
          enable={isUsingDirectLinkWithoutRedirectLanding}
          usageToggle={toggleDirectLinkWithoutRedirectLandingUsage}
          error={errors.directLinkLanding}
          innerRef={_alertRefs.directLinkLanding}
          checkDomain={checkDirectLinkWithoutRedirect}
          domainParking={domainParking}
          domainParkingToggle={domainParkingToggle}
          onDomianParkingInputChange={onDomianParkingInputChange}
          offerCategories={offer.categories}
        />
      )}

      {isEdit && (
        <Card className="flow-prepared-link">
          <Card.Header>
            <Badge>4</Badge>
            <FormattedMessage id="flow.title.edit.theme_4" defaultMessage="Prepared link" />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col
                xs={{ order: 1 }}
                sm={{ order: 1 }}
                md={{ order: 1 }}
                lg={{ order: 1 }}
                xl={{ order: 0, size: 6 }}
              >
                {/* Link */}
                {stream.link && !stream.directLinkLandingWithoutRedirect && (
                  <FlowLink theme={4} history={history} link={getComputedLink(stream.link)} />
                )}
                {stream.directLinkLandingWithoutRedirect && (
                  <FlowLink
                    link={getComputedLink(stream.directLinkLandingWithoutRedirect, '&callsubid=')}
                    id="flow.form.direct-link-without-redirect.title"
                    defaultMessage="Direct link without redirect"
                  />
                )}
              </Col>

              <Col
                xs={{ order: 1, offset: 6 }}
                sm={{ order: 1 }}
                md={{ order: 1 }}
                lg={{ order: 1 }}
                xl={{ order: 1, size: 6, offset: 0 }}
              >
                {stream.editable && stream.link && (
                  <FlowQRCode link={getComputedLink(stream.link)} />
                )}
              </Col>

              {!stream.editable || showWarning ? (
                <Col
                  xs={{ order: 0 }}
                  sm={{ order: 0 }}
                  md={{ order: 0 }}
                  lg={{ order: 0 }}
                  xl={{ order: 1, size: 12, offset: 0 }}
                >
                  {!stream.editable ? <FlowAgencyBanner agency={stream.agency} /> : <FlowWarning />}
                </Col>
              ) : null}
            </Row>

            {/* Parked domain */}
            {settings.clickDomains && settings.clickDomains.length > 0 && (
              <Row>
                <Col xl="6">
                  <FlowParkedDomain
                    sm
                    subAccount={subAccount}
                    encId={stream.encId}
                    domains={settings.clickDomains}
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col xl="6">
                {/* Direct Landing Link */}
                {stream.directLinkLanding && (
                  <FlowLink
                    id="flow.form.direct-landing-link"
                    defaultMessage="Landing Link"
                    link={getComputedLink(stream.directLinkLanding, '&callsubid=')}
                  />
                )}
              </Col>
            </Row>

            <Row>
              <Col xl="6">
                {/* Direct Prelander Link */}
                {stream.directLinkPrelander && (
                  <FlowLink
                    id="flow.form.direct-prelander-link"
                    defaultMessage="Prelander Link"
                    link={getComputedLink(stream.directLinkPrelander, '&callsubid=')}
                  />
                )}
              </Col>
            </Row>

            <Row>
              <Col xl="6">
                {/* Sub Account */}
                <FlowSubAccount onSubAccountChange={handleSubAccountChange} />
              </Col>
            </Row>

            {!isCdn && (
              <Row className="mt-3">
                <Col xl="6">
                  {/* Deep link */}
                  <FlowDeepLink onDeepLinkChange={handleDeepLinkChande} deepLink={deepLink} />
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      )}

      <Card className="flow-info">
        <Card.Body>
          {/* Domain */}
          {isClick && (
            <div ref={_alertRefs.rotator_domain}>
              <Row>
                <Col lg="6">
                  <DomainUrl
                    url={stream.rotator_domain}
                    isEdit={isEdit}
                    onCheckDomain={handleDomainCheck}
                    onUrlChange={handleDomainChange}
                    error={errors.rotator_domain}
                  />
                </Col>
                <Col lg="6">
                  <DomainDisclaimer type={type} parkingType={getParkingType()} />
                </Col>
              </Row>
            </div>
          )}
          <Row>
            <Col lg="6">
              {/* Title */}
              <div ref={_alertRefs.title}>
                <FlowTitle title={stream.title} onChangeTitle={handleChange} error={errors.title} />
              </div>

              {/* Offers */}
              <div ref={_alertRefs.offers}>
                <FormGroup  className="stream-offer-select">
                  <Label>
                    <FormattedMessage id="flow.form.offer" defaultMessage="Offer" />
                  </Label>
                  <Input type="select" name="offer_id" defaultValue={offer.id} disabled>
                    <option value={offer.id}>{offer.title}</option>
                  </Input>
                </FormGroup>
              </div>
            </Col>
            <Col lg="6">
              {/* Source */}
              <div ref={_alertRefs.site}>
                <FlowSources
                  theme={4}
                  sourceId={stream.siteId}
                  sources={sites}
                  onSiteChange={handleSiteChange}
                  error={errors.site}
                />
              </div>

              {/* Agency */}
              {!isEdit &&
                !isClick &&
                Array.isArray(settings.agencies) &&
                settings.agencies.length > 0 && (
                  <>
                    <FlowAgencies
                      theme={4}
                      className="no-margin"
                      agency={stream.agency}
                      agencies={settings.agencies}
                      onAgencyChange={handleAgencyChange}
                      disabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
                    />
                    {showVkCabinetSubtext ? (
                      <div className="pt-2">
                        <FMessage id="flow.form.agency.vk.warning" />
                        <a
                          onClick={handleClickVkWarningLink}
                          className="flow-agency-warning-link"
                          tabIndex={1}
                        >
                          <FMessage id="flow.form.agency.vk.warning.link" />
                        </a>
                      </div>
                    ) : null}
                  </>
                )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div ref={_alertRefs.landings}>
        {errors.landings && <Alert color="danger">{errors.landings}</Alert>}
      </div>

      <Row>
        <Col>
          <FormGroup>
            <Button color="primary" disabled={stream.offerId === 0 || loading || isUserBlocked}>
              {isEdit ? (
                <FormattedMessage id="flow.buttons.save" defaultMessage="Save a flow" />
              ) : (
                <FormattedMessage id="flow.buttons.create" defaultMessage="Create a flow" />
              )}
            </Button>
          </FormGroup>
        </Col>
      </Row>

      <AlertModal open={modal} message={message} onClose={toggleModal} />
      <IframeConstructorModal
        open={iframeConstructorModalOpen}
        toggle={toggleIframeConstructorModal}
        submit={handleIframeConstructorSubmit}
        settings={iframeConstructorSettings}
        link={getComputedLink(stream.link)}
      />
    </Form>
  );
};

export default View;
